import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '../query-keys';
import { useContentApi } from './use-content-api';
import { Faq } from '../../../services/content-api/types/faq.types';

const faqGraphQlQuery = `{
    listUpskillFaqs(limit: 100, sort: order_ASC) {
      data {
        id
        header
        body
      }
  }
  }`;
export const useGetFaqContent = () => {
  const contentApi = useContentApi();
  return useQuery<Faq[]>({
    queryKey: QUERY_KEYS.learning.content.getFaq(),
    queryFn: () =>
      contentApi.graphQl
        .getFaq(faqGraphQlQuery)
        .then((res) => (res?.body?.listUpskillFaqs?.data ?? []) as Faq[]),
  });
};
